import type { ReactNode } from "react";

type ButtonVariant = "primary" | "accent" | "light" | "outline";

interface ButtonProps {
  href: string;
  children: ReactNode;
  variant?: ButtonVariant;
  external?: boolean;
  className?: string;
  ariaLabel?: string;
  /** Evento del Píxel de Meta, leído por la delegación global de clics. */
  fbEvent?: string;
  /** Valor de `content_name` para ese evento. */
  fbLabel?: string;
}

const variants: Record<ButtonVariant, string> = {
  primary: "bg-primary-500 text-foreground-950 hover:bg-primary-600",
  accent: "bg-accent-500 text-background-50 hover:bg-accent-600",
  light: "bg-background-50 text-foreground-950 hover:bg-background-100",
  outline:
    "border border-background-300 bg-background-50 text-foreground-900 hover:bg-background-100",
};

export default function Button({
  href,
  children,
  variant = "primary",
  external = false,
  className = "",
  ariaLabel,
  fbEvent,
  fbLabel,
}: ButtonProps) {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      data-fb-event={fbEvent}
      data-fb-label={fbLabel}
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      className={`inline-flex min-h-[44px] items-center justify-center gap-2 rounded-md px-5 py-2.5 text-sm font-label font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 ${variants[variant]} ${className}`}
    >
      {children}
    </a>
  );
}